import React, { Suspense, useMemo, useState, useTransition } from "react";
import { Col, Row } from "reactstrap";  
import DetailViewLayout from "components/list/DetailViewLayout";
import { useList } from "hooks/useList";
import LoaderComponent from "./Loader";
import ApiError from "./ApiError";
import { getListComponent } from "utils/moduleRegistry";
import { getViewComponent } from "utils/moduleRegistry";

function EmbeddedList({ type, filters=null, reduced=false, context, select=null, view=null, selectedItems, setSelectedItems, listView }) {
    const [selectedItem, setSelectedItem] = useState(null);
    const list = useList(type, null, null, null, JSON.stringify(filters));
    const ListComponent = useMemo(() => view ? getViewComponent(view) : getListComponent(type), [view, type]);
    const [isPending, startTransition] = useTransition();
    const [lastSelection, setLastSelection] = useState (null); 

    const handleSelect = (item) => {
        startTransition(() => {
            if(select){
                select(item)
            } else {
                setSelectedItem(item)
            }
        });
    }

    if (list.error) return <ApiError retryFetch={list.refetch} errorMessage={list.error.message} />
    return (
        <div className="content">
            <Row>
                <Col md="12">
                    {selectedItem != null ? 
                        <DetailViewLayout
                            context={context}
                            list={list}
                            selectedItem={selectedItem} 
                            setSelectedItem={handleSelect} 
                        />
                    : 
                        <Suspense fallback={<LoaderComponent/>}>
                            <ListComponent
                                type={type}
                                data={list}
                                listView={listView}
                                selectedItem={selectedItem} 
                                setSelectedItem={handleSelect} 
                                reduced={reduced}
                                context={context}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                lastSelection={lastSelection}
                                setLastSelection={setLastSelection}
                            />
                        </Suspense>
                    }
                </Col>
            </Row>
        </div>
    );
}

export default EmbeddedList;